module.exports = __webpack_public_path__ + "img/4.beab557b.png";